import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon } from 'lucide-react';
import type { WarrantyTier } from '../../data/pricing';
import { useLanguage } from '../../contexts/LanguageContext';
import { warrantyLabel } from '../../utils/pricing';
type WarrantyTagProps = {
  tier: WarrantyTier;
  /** Link the label to the published warranty details. Avoid inside other links/buttons. */
  linked?: boolean;
};
export function WarrantyTag({
  tier,
  linked = false
}: WarrantyTagProps) {
  const {
    lang
  } = useLanguage();
  const content = <>
      <ShieldCheckIcon className={`h-4 w-4 shrink-0 ${tier === 'lifetime' ? 'text-marine' : 'text-titanium'}`} aria-hidden data-id="element-971" data-mp="2k0pts3kaxtym" />
      <span className={tier === 'lifetime' ? 'text-white' : ''} data-id="element-972" data-mp="2txlu3m01r9s3">{warrantyLabel(tier, lang).label}</span>
    </>;
  const cls = 'inline-flex flex-wrap items-center gap-1.5 text-sm text-titanium';
  if (!linked) return <span className={cls} data-id="element-973" data-mp="9625mqtiviam">{content}</span>;
  return <Link to="/warranty" className={`${cls} underline decoration-white/20 underline-offset-4 transition-colors duration-150 hover:text-white hover:decoration-ice focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ice`} data-id="element-974" data-mp="98odkrkbrztd">
      {content}
    </Link>;
}